import { ReviewResult } from '../../../../enums';
import { ICodReview } from './cod-review.interface';

export interface IReassignment extends Omit<ICodReview, 'reason'> {
    assignee: string;
    reviewResult: ReviewResult;
}
